import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import RangeFilter from '../../../../common/RangeFilter';
import { fetchAnalyticsData } from '../actions';
import { getIsFetching } from '../selectors';

export default compose(
  connect(
    state => ({
      isFetching: getIsFetching(state),
    }),
    { fetchAnalyticsData }
  ),
  withHandlers({
    onFilterChange: () => () => {

    },
    onDateChange: props => (firstFrom, firstTo, secondFrom, secondTo) => {
      props.onChange(firstFrom, firstTo, secondFrom, secondTo);
    },
  }),
)(RangeFilter);
